import _ from "lodash";

import { dateRanges } from "../../modules/reviews/ReviewFilterStore"
import reviewFiltersStore from "../../modules/reviews/ReviewFilterStore";
import { bindReviewFiltersAndSelectedLocationToAngular } from "./filterBindingUtils";

let moment = require('moment');

angular.module('clientDashboardApp').controller("LocationComparisonReportController",
  function ($scope, $sce, reviewService, $location, $timeout, $log, reactContainer) {

    $scope.processStack = []
    var previousFilter = {}
    $scope.providers = [];
    $scope.pagination = {}

    initializeForm()

    $scope.$on('$locationChangeSuccess', () => {
      initializeForm()
    });

    function initializeForm() {
      const params = $location.search();
      $scope.pagination.page = (params.page) ? Number(params.page) : 1;
      if (!$scope.reportSearchConfig) {
        $scope.reportSearchConfig = {};
        bindReviewFiltersAndSelectedLocationToAngular($scope, $scope.reportSearchConfig);
        executeSearch();
      }
    }

    $scope.$watch("reportSearchConfig", (newVal, oldVal) => {
      if (angular.equals(newVal, oldVal)) {
        return;
      }
      if (newVal == oldVal) {
        return;
      }
      $timeout(function() {
        searchFormToStateChange(1)
      }, 100)
    }, true);

    $scope.selectAllProviders = () => {
      $scope.reportSearchConfig.providers = _.map($scope.providers, p=> p.id)
    }

    function searchFormToStateChange(pageToMove) {
      $scope.pagination.page = pageToMove;
      if ($scope.showGroups == false) {
        executeSearch()
      }
    }

    function isDuplicateSearch(filter) {
      return angular.equals(previousFilter, filter)
    }

    function executeSearch() {
      if (!isDateRangeValid()) {
        return
      }
      var filter = createSearchFilter();

      if (!isDuplicateSearch(filter)) {
        previousFilter = filter;
        $scope.processStack.push("searching");
        reviewService.locationComparisonReport(filter).then(response => {
          processSearchResults(response, filter);
          $scope.processStack.pop();
        });
      }
    }

    function processSearchResults(response, filters) {
      $scope.searchResults = response
      $scope.comparisonExportToken = {
        'export': () => {
          let exportFilters = angular.copy(filters);
          return reviewService.exportComparisonData(exportFilters);
        },
        totalResults: 0
      }
    }


    function isDateRangeValid() {
      return ($scope.reportSearchConfig.startDate && $scope.reportSearchConfig.endDate);
    }

    function createSearchFilter() {
      var filter = {};
      filter.groupId = reviewFiltersStore.state.groupId;
      filter.page = $scope.pagination.page;
      filter.range = $scope.reportSearchConfig.range;
      filter.compareToPreviousPeriod = $scope.reportSearchConfig.compareToPreviousPeriod;
      
      const selected = dateRanges.find(range =>
        range.to.diff($scope.reportSearchConfig.endDate, "days") === 0 &&
        range.from.diff($scope.reportSearchConfig.startDate, "days") === 0
      );
      
      filter.reportRange = !!selected && selected.id !== "LastDay" ? selected.id : "SpecificDates";
      
      if ($scope.reportSearchConfig.startDate && filter.reportRange !== "AllTime") {
        filter.startDate = moment($scope.reportSearchConfig.startDate).format("YYYY-MM-DD")
      }

      if ($scope.reportSearchConfig.endDate && filter.reportRange !== "AllTime") {
        filter.endDate = moment($scope.reportSearchConfig.endDate).format("YYYY-MM-DD")
      }

      if ($scope.reportSearchConfig.providers) {
        filter.providers = $scope.reportSearchConfig.providers.join()
      }
      filter.sortField = $scope.reportSearchConfig.sortField;
      filter.sortOrder = $scope.reportSearchConfig.sortOrder;

      return filter
    }

    $scope.showRecommendations = () => {
      return !$scope.reportSearchConfig.providers.length || $scope.reportSearchConfig.providers.indexOf('FACEBOOK') >= 0
    }

    $scope.getReportSortIcon = function (column) {
      if ($scope.reportSearchConfig.sortField === column) {
        if ($scope.reportSearchConfig.sortOrder === 'ASC') {
          return 'fa-sort-up';
        } else {
          return 'fa-sort-down';
        }
      } else {
        return 'fa-sort';
      }
    };

    $scope.sortReportTable = function (sortColumn) {
      if ($scope.reportSearchConfig.sortField === sortColumn) {
        if ($scope.reportSearchConfig.sortOrder === 'ASC') {
          $scope.reportSearchConfig.sortOrder = 'DESC';
        } else {
          $scope.reportSearchConfig.sortOrder = 'ASC';
        }
      } else {
        $scope.reportSearchConfig.sortField = sortColumn;
        $scope.reportSearchConfig.sortOrder = 'DESC';
      }
    };

    $scope.ratingPercentage = (report, ratingField) => {
      const storeComparison = report.storeComparison || {};
      if ($scope.reportSearchConfig.compareToPreviousPeriod) {
        return ""
      } else if (storeComparison.count && storeComparison.count > 0) {
        const percentage = storeComparison[ratingField] / storeComparison.count;
        const change = Math.round(percentage*100);
        return `<span> ${storeComparison[ratingField].toLocaleString()} ${change}%</span>`;
      } else {
        return "<span class='value-with-change'>" + storeComparison[ratingField].toLocaleString() + "</span>"
      }
    }

    $scope.formatRecommendationData = (summary, showIcon) => {
      const storeComparison = summary.storeComparison || {};
      const { totalRecommended, totalNotRecommended } = storeComparison;
      if (summary && angular.isDefined(totalRecommended) && angular.isDefined(totalNotRecommended)) {
        return `
        <div class='value-with-change'><span class="far fa-thumbs-up"></span> ${totalRecommended.toLocaleString()} ${formatChangePercentage(summary.change['totalRecommended'], showIcon)} </div>
        <div class='value-with-change'><span class="far fa-thumbs-down"></span> ${totalNotRecommended.toLocaleString()} ${formatChangePercentage(summary.change['totalNotRecommended'], showIcon)} </div>`
      }
      else {
        return "-"
      }
    }

    $scope.formatValueAndChangePercentage = function (summary, property, showIcon) {
      const storeComparison = summary.storeComparison || {};
      if (summary && angular.isDefined(storeComparison[property])) {
        return "<span class='value-with-change'> " + storeComparison[property].toLocaleString() + " " + formatChangePercentage(summary.change[property], showIcon) + "</span>"
      } else {
        return "-"
      }
    }

    $scope.formatValueAndChangePercentageRespondedCell = function (summary, showIcon) {
      const storeComparison = summary.storeComparison || {};
      if (summary && angular.isDefined(storeComparison['respondedCount']) && angular.isDefined(storeComparison['countThatCanBeRespondedTo'])) {
        const thisPeriod = (storeComparison['respondedCount'] / storeComparison['countThatCanBeRespondedTo'])
        const lastPeriodResponded = storeComparison['respondedCount'] * (1 + summary.change['respondedCount'] / 100)
        const lastPeriodPossible = summary.change['countThatCanBeRespondedTo']
        const lastPeriod = lastPeriodResponded / lastPeriodPossible;

        const delta = ((thisPeriod - lastPeriod) / lastPeriod) * 100;

        // Shows # Reviews Responded To Divided By # Reviews That Were Possible to respond to
        // The delta is the percentage change in percentage responded to
        return "<span class='value-with-change'> " + storeComparison['respondedCount'].toLocaleString() + "/" + storeComparison['countThatCanBeRespondedTo'].toLocaleString() + " " + formatChangePercentage(delta, showIcon) + "</span>"
        // Commented out bit shows the previous period
        // + "<span class='value-with-change'> " + Math.floor(lastPeriodResponded) + "/" + lastPeriodPossible + "</span>"
      } else {
        return "-"
      }
    }

    $scope.moveToPage = function() {
      searchFormToStateChange($scope.pagination.page)
    }

    function formatChangePercentage(value, showIcon) {
      if (isNaN(value) || !angular.isDefined(value)) return "";

      let floatValue = Number(value);
      let labelCssClass = "";
      if (showIcon && floatValue !== 0.0) labelCssClass = (floatValue > 0) ? "change-increase" : "change-decrease";
      if (floatValue < 0) floatValue = floatValue * -1.0;
      const formattedValue = (floatValue).toFixed(0);
      return $sce.trustAsHtml("<span class='" + labelCssClass + "'>" + formattedValue + "% " + "</span>");
    }

    searchFormToStateChange($scope.pagination.page);

  });
